import React from "react";
import { motion } from "framer-motion";

const container = {
  hidden: {},
  visible: (delay = 0) => ({ transition: { staggerChildren: 0.028, delayChildren: delay } }),
};
const letter = {
  hidden: { opacity: 0, y: "0.45em" },
  visible: { opacity: 1, y: 0, transition: { duration: 0.32, ease: [0.22, 1, 0.36, 1] } },
};

export const AnimatedTitle = ({ text, className = "", as = "h2", delay = 0 }) => {
  const Tag = motion[as] || motion.h2;
  return (
    <Tag
      className={`calli ${className}`}
      variants={container}
      custom={delay}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-60px" }}
      aria-label={text}
    >
      {Array.from(text).map((ch, i) => (
        <motion.span key={i} variants={letter} aria-hidden="true" style={{ display: "inline-block", whiteSpace: "pre" }}>
          {ch}
        </motion.span>
      ))}
    </Tag>
  );
};
